export const formSkeletonPreloader = () => {
  let isSkeletonVisible = true;

  const hideSkeleton = () => {
    if (isSkeletonVisible) {
      isSkeletonVisible = false;
      $("[data-wm-form-skeleton-preloader]").fadeOut(500);
    }
  };

  hideSkeleton();
};
